export const productMetaFields = [
  { namespace: 'specs', key: 'material' },
  { namespace: 'specs', key: 'inkt' },
  { namespace: 'specs', key: 'finishing' },
  { namespace: 'specs', key: 'inside_print' },
  { namespace: 'specs', key: 'product_unit' },
  { namespace: 'specs', key: 'fsc' },
  { namespace: 'specs', key: 'ean' },
  { namespace: 'specs', key: 'format' },
  { namespace: 'filter', key: 'papierkwaliteit' },
  { namespace: 'custom', key: 'kleurvarianten' },
  { namespace: 'custom', key: 'kleur_filter' },
  { namespace: 'custom', key: 'kleur_label' },
  { namespace: 'custom', key: 'kleurcode' },
  { namespace: 'custom', key: 'dubbelzijdig' },
  { namespace: 'filter', key: 'gelijk_of_mix' },
  { namespace: 'filter', key: 'vorm' },
  { namespace: 'filter', key: 'stijl' },
  { namespace: 'filter', key: 'handgrepen' },
  { namespace: 'filter', key: 'retourstrip' },
  { namespace: 'filter', key: 'ontwerp' },
  { namespace: 'filter', key: 'theme' },
  { namespace: 'custom', key: 'custom_label' },
];

export const variantMetaFields = [
  { namespace: 'website', key: 'color_code' },
  { namespace: 'custom', key: 'kleur_afbeelding' },
  { namespace: 'custom', key: 'formaat' },
  { namespace: 'custom', key: 'kleurvarianten' },
  { namespace: 'custom', key: 'kleur_filter' },
  { namespace: 'custom', key: 'kleur_label' },
  { namespace: 'custom', key: 'kleurcode' },
  { namespace: 'custom', key: 'dubbelzijdig' },
  { namespace: 'specs', key: 'product_unit_variant' },
  { namespace: 'specs', key: 'finishing' },
  { namespace: 'specs', key: 'fsc' },
  { namespace: 'filter', key: 'gelijk_of_mix' },
  { namespace: 'filter', key: 'handgrepen' },
  { namespace: 'specs', key: 'material' },
  { namespace: 'filter', key: 'ontwerp' },
  { namespace: 'filter', key: 'papierkwaliteit' },
  { namespace: 'filter', key: 'theme' },
  { namespace: 'filter', key: 'retourstrip' },
  { namespace: 'filter', key: 'stijl' },
  { namespace: 'filter', key: 'vorm' },
];

export function productListCard(queryBase: any, client: any) {
  queryBase.add('id');
  queryBase.add('title');
  queryBase.add('handle');
  queryBase.add('vendor');
  queryBase.add('productType');
  queryBase.add('availableForSale');
  queryBase.add('priceRange', (price: any) => {
    price.add('minVariantPrice', (min: any) => {
      min.add('amount');
      min.add('currencyCode');
    });
  });
  queryBase.addConnection('images', { args: { first: 20 } }, (images: any) => {
    images.add('src');
    images.add('id');
    images.add('altText');
    images.add('url', { args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } } });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
      alias: 'w_350',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
      alias: 'w_200',
    });
  });
  queryBase.addConnection('collections', { args: { first: 1 } }, (collection: any) => {
    collection.add('id');
    collection.add('title');
    collection.add('handle');
  });
  queryBase.add(
    'metafield',
    {
      args: { namespace: 'custom', key: 'custom_label' },
    },
    (metafield: any) => {
      metafield.add('id');
      metafield.add('key');
      metafield.add('value');
    }
  );
  queryBase.addConnection('variants', { args: { first: 10 } }, (variants: any) => {
    variants.add('sku');
  });
}

export function productColorListOption(queryBase: any, client: any) {
  queryBase.add('id');
  queryBase.add('handle');
  queryBase.add('availableForSale');
  queryBase.add(
    'metafields',
    {
      args: {
        identifiers: [
          { namespace: 'custom', key: 'kleur_filter' },
          { namespace: 'custom', key: 'kleur_label' },
          { namespace: 'custom', key: 'kleurcode' },
          { namespace: 'custom', key: 'kleur_afbeelding' },
        ],
      },
    },
    (metafields: any) => {
      metafields.add('key');
      metafields.add('value');
      metafields.add('reference', (ref: any) => {
        ref.addInlineFragmentOn('MediaImage', (refImg: any) => {
          refImg.add('id');
          refImg.add('image', (refImgObj: any) => {
            refImgObj.add('src');
            refImgObj.add('id');
            refImgObj.add('altText');
            refImgObj.add('url', {
              args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxHeight: 400 } },
            });
          });
        });
      });
    }
  );

  queryBase.addConnection('variants', { args: { first: 250 } }, (variants: any) => {
    variants.add(
      'metafields',
      {
        args: {
          identifiers: [
            { namespace: 'website', key: 'color_code' },
            { namespace: 'custom', key: 'kleur_afbeelding' },
            { namespace: 'custom', key: 'formaat' },
            { namespace: 'custom', key: 'kleurvarianten' },
            { namespace: 'custom', key: 'kleur_filter' },
            { namespace: 'custom', key: 'kleur_label' },
            { namespace: 'custom', key: 'kleurcode' },
            { namespace: 'custom', key: 'dubbelzijdig' },
            { namespace: 'specs', key: 'product_unit_variant' },
          ],
        },
      },
      (metafields: any) => {
        metafields.add('key');
        metafields.add('value');
        metafields.add('type');
      }
    );

    variants.add(
      'metafield',
      {
        args: { namespace: 'website', key: 'variant_images' },
      },
      (metafield: any) => {
        metafield.add('key');
        metafield.add('value');
        metafield.add('type');
        metafield.addConnection('references', { args: { first: 250 } }, (ref: any) => {
          ref.addInlineFragmentOn('MediaImage', (refImg: any) => {
            refImg.add('id');
            refImg.add('image', (refImgObj: any) => {
              refImgObj.add('src');
              refImgObj.add('id');
              refImgObj.add('altText');
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200 } },
                alias: 'w_1200',
              });
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1000 } },
                alias: 'w_1000',
              });

              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
                alias: 'w_800',
              });
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
                alias: 'w_500',
              });
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
                alias: 'w_350',
              });
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
                alias: 'w_200',
              });
            });
          });
        });
      }
    );
  });
  //collection.add(
  //  'metafield',
  //  {
  //    args: { namespace: 'custom', key: 'header_image' },
  //  },
  //  (metafield: any) => {
  //    metafield.add('key');
  //    metafield.add('value');
  //    metafield.add('type');
  //    metafield.add('reference', (ref: any) => {
  //      ref.addInlineFragmentOn('MediaImage', (refImg: any) => {
  //        refImg.add('id');
  //        refImg.add('image', (refImgObj: any) => {
  //          refImgObj.add('src');
  //          refImgObj.add('id');
  //          refImgObj.add('altText');
  //          refImgObj.add('url', { args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxHeight: 1600 } } });
  //        });
  //      });
  //    });
  //  }
  //);
}

export function productCard(queryBase: any, client: any) {
  queryBase.add('id');
  queryBase.add('title');
  queryBase.add('handle');
  queryBase.add('publishedAt');
  queryBase.add('vendor');
  queryBase.add('productType');
  queryBase.add('availableForSale');
  queryBase.add('priceRange', (price: any) => {
    price.add('minVariantPrice', (min: any) => {
      min.add('amount');
      min.add('currencyCode');
    });
  });
  queryBase.add('compareAtPriceRange', (price: any) => {
    price.add('minVariantPrice', (min: any) => {
      min.add('amount');
      min.add('currencyCode');
    });
    price.add('maxVariantPrice', (max: any) => {
      max.add('amount');
      max.add('currencyCode');
    });
  });
  queryBase.addConnection('images', { args: { first: 250 } }, (images: any) => {
    images.add('src');
    images.add('id');
    images.add('altText');
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200 } },
      alias: 'w_1200',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
      alias: 'w_800',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
      alias: 'w_500',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
      alias: 'w_350',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
      alias: 'w_200',
    });
  });
  queryBase.add('options', (options: any) => {
    options.add('values');
    options.add('name');
    options.add('id');
  });
  queryBase.addConnection('collections', { args: { first: 250 } }, (collection: any) => {
    collection.add('id');
    collection.add('title');
    collection.add('handle');
  });

  queryBase.addConnection('variants', { args: { first: 250 } }, (variants: any) => {
    variants.add('id');
    variants.add('product');
    variants.add('title');
    // variants.add('price');
    variants.add('availableForSale');
    variants.add('quantityAvailable');
    variants.add('currentlyNotInStock');
    variants.add('sku');
    variants.add('image', (image: any) => {
      image.add('src');
      image.add('id');
      image.add('altText');
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200 } },
        alias: 'w_1200',
      });

      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
        alias: 'w_800',
      });
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
        alias: 'w_500',
      });
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
        alias: 'w_350',
      });
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
        alias: 'w_200',
      });
    });
    variants.add('selectedOptions', (o: any) => {
      o.add('name');
      o.add('value');
    });
    variants.add('unitPrice', (o: any) => {
      o.add('currencyCode');
      o.add('amount');
    });
    variants.add(
      'metafields',
      {
        args: {
          identifiers: [
            { namespace: 'website', key: 'color_code' },
            { namespace: 'custom', key: 'kleur_afbeelding' },
            { namespace: 'custom', key: 'kleur_filter' },
            { namespace: 'custom', key: 'kleur_label' },
            { namespace: 'custom', key: 'kleurcode' },
            { namespace: 'custom', key: 'kleur_afbeelding' },
          ],
        },
      },
      (metafields: any) => {
        metafields.add('key');
        metafields.add('value');
      }
    );

    // TODO refacor? makes the overview pages a lot slower, maybe seperate call?
    // variants.add(
    //   'metafield',
    //   {
    //     args: { namespace: 'website', key: 'variant_images' },
    //   },
    //   (metafield: any) => {
    //     metafield.add('key');
    //     metafield.add('value');
    //     metafield.add('type');
    //     metafield.addConnection('references', { args: { first: 250 } }, (ref: any) => {
    //       ref.addInlineFragmentOn('MediaImage', (refImg: any) => {
    //         refImg.add('id');
    //         refImg.add('image', (refImgObj: any) => {
    //           refImgObj.add('src');
    //           refImgObj.add('id');
    //           refImgObj.add('altText');
    //           refImgObj.add('url', { args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 600 } } });
    //         });
    //       });
    //     });
    //   }
    // );
  });

  queryBase.add(
    'metafield',
    {
      args: { namespace: 'custom', key: 'custom_label' },
    },
    (metafield: any) => {
      metafield.add('id');
      metafield.add('key');
      metafield.add('value');
    }
  );
}

export function productDetail(queryBase: any, client: any) {
  queryBase.add('id');
  queryBase.add('title');
  queryBase.add('handle');
  queryBase.add('createdAt');
  queryBase.add('description');
  queryBase.add('descriptionHtml');
  queryBase.add('productType');
  queryBase.add('publishedAt');
  queryBase.add('tags');
  queryBase.add('updatedAt');
  queryBase.add('vendor');
  queryBase.add('availableForSale');
  queryBase.add('totalInventory');

  queryBase.add('priceRange', (price: any) => {
    price.add('minVariantPrice', (min: any) => {
      min.add('amount');
      min.add('currencyCode');
    });
    price.add('maxVariantPrice', (max: any) => {
      max.add('amount');
      max.add('currencyCode');
    });
  });
  queryBase.add('compareAtPriceRange', (price: any) => {
    price.add('minVariantPrice', (min: any) => {
      min.add('amount');
      min.add('currencyCode');
    });
    price.add('maxVariantPrice', (max: any) => {
      max.add('amount');
      max.add('currencyCode');
    });
  });
  //[350, 500, 800, 1200]
  queryBase.addConnection('images', { args: { first: 250 } }, (images: any) => {
    images.add('src');
    images.add('id');
    images.add('altText');
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200 } },
      alias: 'w_1200',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
      alias: 'w_800',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
      alias: 'w_500',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
      alias: 'w_350',
    });
    images.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
      alias: 'w_200',
    });
  });
  queryBase.addConnection('media', { args: { first: 250 } }, (mediaItem: any) => {
    mediaItem.add('id');
    mediaItem.add('alt');
    mediaItem.add('mediaContentType');

    mediaItem.add('previewImage', (img: any) => {
      img.add('src');
      img.add('id');
      img.add('altText');
      img.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200, maxHeight: 1500 } },
      });
      img.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
        alias: 'w_800',
      });
      img.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
        alias: 'w_500',
      });
      img.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
        alias: 'w_350',
      });
      img.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
        alias: 'w_200',
      });
    });

    mediaItem.addInlineFragmentOn('Video', (refVideo: any) => {
      refVideo.add('id');
      refVideo.add('sources', (video: any) => {
        video.add('url');
        video.add('format');
      });
    });

    mediaItem.addInlineFragmentOn('ExternalVideo', (refVideo: any) => {
      refVideo.add('id');
      refVideo.add('host');
      refVideo.add('embedUrl');
      refVideo.add('embeddedUrl');
      refVideo.add('mediaContentType');
      refVideo.add('alt');
    });
  });
  queryBase.add('seo', (s: any) => {
    s.add('title');
    s.add('description');
  });
  queryBase.add('featuredImage', (image: any) => {
    image.add('src');
    image.add('id');
    image.add('altText');
    image.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200 } },
      alias: 'w_1200',
    });

    image.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
      alias: 'w_800',
    });
    image.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
      alias: 'w_500',
    });
    image.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
      alias: 'w_350',
    });
    image.add('url', {
      args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
      alias: 'w_200',
    });
  });
  queryBase.add('options', (options: any) => {
    options.add('values');
    options.add('name');
    options.add('id');
  });
  queryBase.add('metafields', { args: { identifiers: productMetaFields } }, (metafields: any) => {
    metafields.add('key');
    metafields.add('value');
    metafields.add('type');
  });
  queryBase.add(
    'metafield',
    {
      args: { namespace: 'custom', key: 'patern_file' },
    },
    (metafield: any) => {
      metafield.add('key');
      metafield.add('value');
      metafield.add('type');
      metafield.add('reference', (ref: any) => {
        ref.addInlineFragmentOn('GenericFile', (refImg: any) => {
          refImg.add('id');
          refImg.add('url');
        });
      });
    }
  );
  queryBase.addConnection('collections', { args: { first: 250 } }, (collection: any) => {
    collection.add('id');
    collection.add('title');
    collection.add('handle');
  });
  queryBase.addConnection('variants', { args: { first: 250 } }, (variants: any) => {
    variants.add('id');
    variants.add('product');
    variants.add('title');
    // variants.add('price');
    variants.add('availableForSale');
    variants.add('quantityAvailable');
    variants.add('currentlyNotInStock');
    variants.add('sku');
    variants.add('barcode');
    variants.add('selectedOptions', (o: any) => {
      o.add('name');
      o.add('value');
    });
    variants.add('price', (o: any) => {
      o.add('currencyCode');
      o.add('amount');
    });
    variants.add('compareAtPrice', (o: any) => {
      o.add('currencyCode');
      o.add('amount');
    });

    variants.add(
      'metafields',
      {
        args: {
          identifiers: [...variantMetaFields],
        },
      },
      (metafields: any) => {
        metafields.add('key');
        metafields.add('value');
        metafields.add('type');
      }
    );

    variants.add(
      'metafield',
      {
        args: { namespace: 'website', key: 'variant_images' },
      },
      (metafield: any) => {
        metafield.add('key');
        metafield.add('value');
        metafield.add('type');
        metafield.addConnection('references', { args: { first: 250 } }, (ref: any) => {
          ref.addInlineFragmentOn('MediaImage', (refImg: any) => {
            refImg.add('id');
            refImg.add('image', (refImgObj: any) => {
              refImgObj.add('src');
              refImgObj.add('id');
              refImgObj.add('altText');
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200 } },
                alias: 'w_1200',
              });

              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
                alias: 'w_800',
              });
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
                alias: 'w_500',
              });
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
                alias: 'w_350',
              });
              refImgObj.add('url', {
                args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
                alias: 'w_200',
              });
            });
          });
        });
      }
    );

    variants.add('image', (image: any) => {
      image.add('src');
      image.add('id');
      image.add('altText');
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 1200 } },
        alias: 'w_1200',
      });

      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 800 } },
        alias: 'w_800',
      });
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 500 } },
        alias: 'w_500',
      });
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 350 } },
        alias: 'w_350',
      });
      image.add('url', {
        args: { transform: { crop: client.enum('CENTER'), preferredContentType: client.enum('WEBP'), maxWidth: 200 } },
        alias: 'w_200',
      });
    });
  });
}

export function catalogProductResult(queryBase: any, client: any) {
  queryBase.add('pageInfo', (pageInfo: any) => {
    pageInfo.add('hasPreviousPage');
    pageInfo.add('hasNextPage');
    pageInfo.add('endCursor');
  });
  queryBase.add('edges', (edges: any) => {
    edges.add('cursor');

    edges.add('node', (node: any) => {
      node.add('handle');
    });
  });
  queryBase.add('filters', (filters: any) => {
    filters.add('id');
    filters.add('label');
    filters.add('type');
    filters.add('values', (values: any) => {
      values.add('id');
      values.add('label');
      values.add('count');
      values.add('input');
    });
  });
}
